export default function language() {
  return [
    { id: 'en', text: 'English' },
    // { id: 'fr', text: 'French' },
    { id: 'es', text: 'Spanish' }
  ]
}
